import * as React from "react";

export default function ChaosCursor({points}) {
    return <polyline key={`chaosCursor`} points={points.join(" ")} stroke={"green"} fill="none" strokeWidth={4}/>
}
